import { IState } from '../../../store';
import { ICostEstimateDesktopSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export const selectCostEstimation = (state: IState): ICostEstimateDesktopSchema | undefined | null =>
  state.offerData.costEstimationData;
